import * as React from 'react';
import Typography from '@material-ui/core/Typography';

export const DocumentLockedMessage: React.FC<{}> = () => (
  <Typography color="error">
    Du kan ikke redigere dokumentet nå, fordi det først må låses. Dette er for å prøve å unngå at
    flere brukere redigerer samtidig.
  </Typography>
);
